import { useEffect, useRef } from 'react';

type Props = { gameName: string; rules: string; onClose: () => void };

export function RulesModal({ gameName, rules, onClose }: Props) {
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.currentTarget === event.target) onClose();
      }}
    >
      <section className="modal" role="dialog" aria-modal="true" aria-labelledby="rules-title">
        <button ref={closeRef} className="modal-close" onClick={onClose} aria-label="Close rules">
          ×
        </button>
        <p className="eyebrow">How to play</p>
        <h2 id="rules-title">{gameName}</h2>
        <p>{rules}</p>
        <p className="warning-note">Time continues while these rules are open.</p>
      </section>
    </div>
  );
}
